import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { authRepository } from "@/data/repositories";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async () => {
    const viewer = await authRepository.getViewer();
    if (!viewer) throw redirect({ to: "/acceso" });
    if (!viewer.isAdmin) throw redirect({ to: "/portal" });
    return { viewer };
  },
  component: () => <Outlet />,
});
